import { render } from "./aboutView.vue?vue&type=template&id=3d91fa5a&scoped=true"
import script from "./aboutView.vue?vue&type=script&lang=js"
export * from "./aboutView.vue?vue&type=script&lang=js"

import "./aboutView.vue?vue&type=style&index=0&id=3d91fa5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d91fa5a"]])

export default __exports__